import { useCallback } from 'react';

import { extractTrackingDataFromVariation } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/categoryUtils';
import type {
  ProductCategory,
  Variation,
} from 'src/modules/designStudio/helpers/productSelection/types';
import { useCommonTrackingData } from 'src/modules/designStudio/hooks/useCommonTrackingData';
import { buttonPressed } from 'src/shared/telemetry';
import type { ButtonPressed } from 'src/shared/telemetry';

const commonProductSelectionData = {
  primary_cta: false,
  design_studio_mode: 'default',
  feature: 'Design Studio Products',
  button_location: 'design-template-panel',
} as ButtonPressed;

export const useTrackProductSelectionEvent = ({
  category,
}: {
  category: ProductCategory;
}) => {
  const commonTrackingData = useCommonTrackingData();

  const trackRealProductSelectionEvent = useCallback(
    (
      trackProps: Record<string, string>,
      variation: Variation | undefined = undefined,
    ) => {
      buttonPressed({
        ...commonProductSelectionData,
        ...(variation
          ? extractTrackingDataFromVariation(variation, category)
          : {}),
        ...commonTrackingData,
        ...trackProps,
      } as ButtonPressed);
    },
    [commonTrackingData, category],
  );

  return {
    trackRealProductSelectionEvent,
  };
};
